<div class="purchase-power-container">
  <div class="purchase-power-image">
    @if (data.image) {
      <img [src]="data.image" />
    }
  </div>
  <div class="purchase-power-title b-2">
    <span>{{ data.title }}</span>
  </div>

  <div class="w-100 d-flex purchase-power-button">
    <div class="button-container">
      <ngx-button
        [fullWidth]="true"
        mode="form"
        [size]="'medium'"
        (clickHandler)="close()"
      >
        متوجه شدم
      </ngx-button>
    </div>
  </div>
</div>
